import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import "./Header.css";


function Header() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="header">
      <div className="logo">PHARA</div>

      <button
        className={`menu-toggle ${menuOpen ? "open" : ""}`}
        onClick={() => setMenuOpen((prev) => !prev)}
        aria-label={menuOpen ? "Close navigation" : "Open navigation"}
        aria-expanded={menuOpen}
      >
        <span />
        <span />
        <span />
      </button>

      <nav className={`nav ${menuOpen ? "open" : ""}`}>
        <NavLink to="/Home" onClick={() => setMenuOpen(false)}>
          Home
        </NavLink>
        <NavLink to="/AboutUs" onClick={() => setMenuOpen(false)}>
          About Us
        </NavLink>
        <NavLink to="/Contact" onClick={() => setMenuOpen(false)}>
          Contact
        </NavLink>
        <NavLink to="/Description" onClick={() => setMenuOpen(false)}>
          Description
        </NavLink>
        <NavLink to="/Ordering" onClick={() => setMenuOpen(false)}>
          Ordering
        </NavLink>
        <NavLink to="/DrugDetails" onClick={() => setMenuOpen(false)}>
          Drug Details
        </NavLink>
      </nav>
    </header>
  );
}

export default Header;